type stateType = {
  shopId: number
  step: number
  typeCategory: string
  productCategory: string
  locationCategory: string
  date: string
  time: string
  dataByMonth: object
  availableSlots: object
  selectedMonth: number
}

export const state = () => ({
  shopId: 0,
  step: 1,
  productCategory: '',
  locationCategory: '',
  date: '',
  time: '',
  dataByMonth: {},
  availableSlots: {},
  selectedMonth: 0,
})

export const mutations = {
  setShopId(state: stateType, shopId: number) {
    state.shopId = shopId
  },
  setStep(state: stateType, step: number) {
    state.step = step
  },
  setTypeCategory(state: stateType, typeCategory: string) {
    state.typeCategory = typeCategory
  },
  setProductCategory(state: stateType, productCategory: string) {
    state.productCategory = productCategory
  },
  setLocationCategory(state: stateType, locationCategory: string) {
    state.locationCategory = locationCategory
  },
  setDate(state: stateType, date: string) {
    state.date = date
  },
  setTime(state: stateType, time: string) {
    state.time = time
  },
  setDataByMonth(state: stateType, dataByMonth: object) {
    state.dataByMonth = dataByMonth
  },
  setAvailableSlots(state: stateType, availableSlots: object) {
    state.availableSlots = availableSlots
  },
  setSelectedMonth(state: stateType, selectedMonth: number) {
    state.selectedMonth = selectedMonth
  },
}

export const getters = {
  getShopId(state: stateType) {
    return state.shopId
  },
  getStep(state: stateType) {
    return state.step
  },
  getTypeCategory(state: stateType) {
    return state.typeCategory
  },
  getProductCategory(state: stateType) {
    return state.productCategory
  },
  getLocationCategory(state: stateType) {
    return state.locationCategory
  },
  getDate(state: stateType) {
    return state.date
  },
  getTime(state: stateType) {
    return state.time
  },
  getDataByMonth(state: stateType) {
    return state.dataByMonth
  },
  getAvailableSlots(state: stateType) {
    return state.availableSlots
  },
  getSelectedMonth(state: stateType) {
    return state.selectedMonth
  },
}
